<script>
  import { format } from 'svelte-i18n';
  import {
    Alert,
    Button,
    Modal,
    ModalBackdrop,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Progress
  } from '@sveltestrap/sveltestrap';

  import { SearchFilter } from '@client/components/filters/search';
  import { Icon } from '@client/components/icon';

  import { exportDataToCSV } from '@client/utils/csv';

  import StatusTable from './status-table.svelte';

  export let failures = 0;
  export let fields = [];
  export let pushing = false;
  export let results = [];
  export let rows = [];
  export let search;
  export let show = false;
  export let successes = 0;
  export let total = 1;
  export let type = undefined;

  $: current = results.length + 1;

  $: filteredRows =
    search?.length > 1
      ? rows.filter((row) =>
          Object.values(row).some(
            (value) => typeof value === 'string' && value.toLowerCase().includes(search.toLowerCase())
          )
        )
      : rows;

  const onExport = async () => {
    const data = results.map(({ username, success, message }) => ({
      username,
      success,
      message: message ?? ''
    }));

    exportDataToCSV(data, 'push-results');
  };

  const toggle = () => {
    show = false;
  };
</script>

<!-- Needed for double modal to dim parent modal: -->
<ModalBackdrop bind:isOpen={show} style="z-index: 10000" />

<Modal backdrop={false} bind:isOpen={show} fullscreen="lg" scrollable size="lg" {toggle}>
  <ModalHeader {toggle}>
    {$format('label.PUSHER_STATUS')}
  </ModalHeader>

  <ModalBody>
    {#if pushing}
      <Progress value={Math.ceil((current / total) * 100)} />

      <p class="p-3 text-center">
        {$format('label.PUSHER_PROGRESS', {
          values: { n: current, total }
        })}
      </p>
    {:else}
      {#if successes}
        <Alert color="success" class="d-flex align-items-center mb-3">
          <h5 class="mb-0">
            <Icon name="check-circle" />
            {$format('label.PUSHER_SUCCESSES', {
              values: { n: successes }
            })}
          </h5>
          <Button class="ms-auto" color="success" outline on:click={onExport} size="sm"
            >{$format('label.EXPORT_RESULTS')}</Button
          >
        </Alert>
      {/if}
      {#if failures}
        <Alert color="danger" class="d-flex align-items-center mb-3">
          <h5 class="mb-0">
            <Icon name="alert-triangle" />
            {$format('label.PUSHER_FAILURES', {
              values: { n: failures }
            })}
          </h5>
          {#if !successes}
            <Button class="ms-auto" color="danger" outline on:click={onExport} size="sm">
              {$format('label.EXPORT_RESULTS')}
            </Button>
          {/if}
        </Alert>
      {/if}
    {/if}

    <div class="py-3">
      <SearchFilter bind:search />
    </div>
    <StatusTable class="my-3" {fields} {results} rows={filteredRows} {type} />
  </ModalBody>
  <ModalFooter>
    {#if !pushing}
      <Button on:click={toggle}>
        {$format('label.CLOSE')}
      </Button>
    {/if}
  </ModalFooter>
</Modal>
